export const tags = {
    layout: {
        listTitle: 'Tags',
        newTitle: 'Nova tag',
        editTitle: 'Editar tag',
    },
    list: {
        noTransactions: 'Sem transações',
        transactionCount_one: '{{count}} transação',
        transactionCount_other: '{{count}} transações',
        emptyTitle: 'Nenhuma tag',
        emptySubtitle: 'Crie tags para organizar suas transações por contexto (ex: viagem, reembolso).',
        emptyAction: 'Criar tag',
    },
    form: {
        previewPlaceholder: 'sua tag',
        previewLabel: 'Prévia',
        nameLabel: 'Nome',
        namePlaceholder: 'nome da tag',
        // O repositório salva em minúsculas mas mantém os espaços — o {{slug}} é o nome como
        // o extrato vai mostrar, então a frase não pode prometer "sem espaço".
        nameHintNew: 'Ex: viagem, reembolso, presente. Sempre em minúsculas — no extrato, aparece como <0>#{{slug}}</0>.',
        nameHintEdit_zero: 'Nenhuma transação usa esta tag ainda — no extrato, ela aparece como <0>#{{slug}}</0>.',
        nameHintEdit_one: 'Renomear não desfaz nada: <0>{{count}} transação</0> passa a mostrar <0>#{{slug}}</0>.',
        nameHintEdit_other: 'Renomear não desfaz nada: as <0>{{count}} transações</0> passam a mostrar <0>#{{slug}}</0>.',
        colorLabel: 'Cor',
        deleteAction: 'Excluir tag',
        createButton: 'Criar tag',
        saveButton: 'Salvar alterações',
        nameRequiredError: 'Dê um nome à tag',
        saveError: 'Não foi possível salvar a tag.',
    },
    deleteDialog: {
        title: 'Excluir tag',
        messageWithUsage_one: 'A tag será removida de {{count}} transação. As transações em si serão mantidas. Esta ação não pode ser desfeita.',
        messageWithUsage_other: 'A tag será removida de {{count}} transações. As transações em si serão mantidas. Esta ação não pode ser desfeita.',
        messageUnused: 'A tag será excluída. Esta ação não pode ser desfeita.',
        confirm: 'Excluir',
    },
    picker: {
        title: 'Tags',
        searchPlaceholder: 'Buscar ou criar tag...',
        create: 'Criar "{{query}}"',
        empty: 'Nenhuma tag criada',
        menuTitle: 'Tag "{{name}}"',
        edit: 'Editar',
        editDescription: 'Renomear ou mudar a cor',
        delete: 'Excluir tag',
        deleteDescription: 'Remove a tag de todas as transações',
    },
    batchSheet: {
        title: 'Adicionar tags',
        apply_one: 'Aplicar a {{count}} transação',
        apply_other: 'Aplicar a {{count}} transações',
    },
};
